import { ICommand, IDefineCommand, IQueryMediator } from 'core-ts-types';
import { IInterface, IInterfaceDTD } from 'utility-js-interface';
import { IPollBuilderDTD } from '../poll_interfaces';
import { PollStudentDataStore } from './../datastore/poll_student_datastore';

angular
  .module('capability-ng-poll')
  .factory(
    'updatePollStatusCommand',
    function updatePollStatusCommandDeinition(
      $q: ng.IQService,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngPollStudentDataStore: PollStudentDataStore,
      defineCommand: IDefineCommand
    ): ICommand {
      return defineCommand(
        'updatePollStatusCommand',
        function updatePollStatusCommand(deferred: ng.IDeferred<any>, poll: IPollBuilderDTD): any {
          const isAnonymous: boolean = poll.is_anonymous ? poll.is_anonymous : false;
          const status: boolean = poll.is_completed;
          $http
            .put(`poll/${poll.id}/student`, {
              is_completed: status,
              is_anonymous: isAnonymous
            })
            .then((): void => {
              deferred.resolve(
                QueryMediator.runQueries(
                  ngPollStudentDataStore.write({
                    is_completed: status,
                    is_anonymous: isAnonymous
                  })
                )
              );
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/update_poll_status_command.ts